package com.narbase.narnic.trial.sections.testimonials

import com.narbase.bos.common.data.AppColors
import com.narbase.kunafa.core.components.*
import com.narbase.kunafa.core.components.layout.LinearLayout
import com.narbase.kunafa.core.css.*
import com.narbase.kunafa.core.dimensions.dependent.matchParent
import com.narbase.kunafa.core.dimensions.dependent.weightOf
import com.narbase.kunafa.core.dimensions.dependent.wrapContent
import com.narbase.kunafa.core.dimensions.percent
import com.narbase.kunafa.core.dimensions.px
import com.narbase.narnic.trial.utils.horizontalFiller
import com.narbase.narnic.trial.utils.popup.VideoViewer
import com.narbase.narnic.trial.utils.translations.localized
import com.narbase.narnic.trial.utils.verticalFiller
import kotlinx.dom.appendText

class TestimonialsSection : Component() {

    override fun View?.getView(): View = verticalLayout {
        style {
            width = matchParent
            alignItems = Alignment.Center
            id = "clientTestimonials"
        }

        textView {
            style {
                fontWeight = "600"
                fontSize = 16.px
                color = AppColors.narnicVeryDarkColor
                textAlign = TextAlign.Center
                textTransform = "uppercase"
            }
            text = "Don't just take our word for it\n listen to our clients".localized()
        }
        verticalFiller(64)

        horizontalLayout {
            style {
                width = matchParent
                direction = "ltr"
            }

            horizontalLayout {
                style {
                    this["width"] = "max-content"
                    animation = "scroll 40s linear infinite"

                }

                val parentLayout = this
                repeat(2) {
                    khawlaVideo(parentLayout)
                    testimonialView(
                        parentLayout,
                        "Dr. Sinan Khudhur".localized(),
                        "Alibtesam Al lulueyah Dental Clinic".localized(),
                        "We are Alibtesam Al Lulueyah Dental Clinic in Sharjah. We have been using the Medic system for our clinic for the past few months. It is the easiest system we have ever used, characterized by its easy accessibility and user-friendliness for both staff and doctors. We have also received excellent cooperation from the team in charge. Since implementing this system, we have not encountered any issues. Therefore, I strongly recommend this system to other clinics.".localized(),
                        "/public/img/medico/sinan.png.webp",
                        "/public/img/logos/logo_26.webp",
                    )
                    fluentHamzaVideo(parentLayout)
                    testimonialView(
                        parentLayout,
                        "Dr. Mohammed Sedeeq".localized(),
                        "BWell Wellness Center".localized(),
                        "As a dental specialty medical center, we sought an EMR that met our expectations, and Balsam Medico exceeded them. It greatly aids our operations, from scheduling appointments to managing consent forms. Additionally, it seamlessly integrates dental treatment options, ICD codes, and insurance systems like Eclaim, along with financial details. After 18 months of use, we highly recommend Balsam Medico and are extremely satisfied with its services.".localized(),
                        "/public/img/medico/moh-sedeeq.png.webp",
                        "/public/img/logos/logo_8.webp",
                    )
                    vibesDrSharifVideo(parentLayout)
                    testimonialView(
                        parentLayout,
                        "Dr. Islam Nubi".localized(),
                        "Nubi Dental Clinic".localized(),
                        "Balsam Medico application has created a qualitative shift in the nature of the center’s work. It has moved the center from working in a paper format to a fully digital format with complete ease, highly organised and clever way. We are looking forward to making updates with the Narbase Technology staff in the future. I advise dentists who faces such obstacles to start medico in their clinics and centers  as soon as possible".localized(),
                        "/public/img/medico/islam-nubi.png.webp",
                        "/public/img/logos/logo_15.webp",
                    )
                    aldeyhafaNetVideo(parentLayout)
                    bwellDrNoorVideo(parentLayout)
                    drSamarMyChildAndIVideo(parentLayout)


                }
            }
        }
    }

    private fun View.vibesDrSharifVideo(parentLayout: View) {
        videoTestimonial(parentLayout, 1, "Dr. Sharif Awad", "Vibes Aesthetic Clinic") {
            text = ""
            append("My experience with Medico was ")
            appendBold("very beautiful")
            append(" because, ultimately, the system has ")
            appendBold("everything")
            append(" we need as a clinic")
        }
    }

    private fun View.khawlaVideo(parentLayout: View) {
        videoTestimonial(parentLayout, 2, "Khawla Osman", "Vibes Aesthetic Clinic") {
            text = ""
            append("Truly, the system is a ")
            appendBold("'balsam' (healing)")
            append(" indeed. It is always updated. Anything that needs adjusting, they fix it right away. We are honestly grateful to you for your efforts")
        }
    }

    private fun View.fluentHamzaVideo(parentLayout: View) {
        videoTestimonial(parentLayout, 3, "Dr. Hamza Alshathely", "Fluent Physical Medicine & Rehabilitation Center") {
            text = ""
            append("We are impressed with the team performance. The platform is ")
            appendBold("very beautiful")
            append(", its usage is very good, and we can utilize all the ")
            appendBold("medical and financial")
            append(" capabilities within it")

        }
    }

    private fun View.aldeyhafaNetVideo(parentLayout: View) {
        videoTestimonial(parentLayout, 4, "Mary Ann", "Al Dehyafa Dental Clinic") {
            text = ""
            append("We have been using Balsam Medico in our two branches for over three years, and ")
            appendBold("our experience has been excellent.")
            append(" It is very user-friendly and ")
            appendBold("simplifies our daily insurance operations")
//            append(", including prior approvals, requests, and both individual and bulk claim submissions, as well as payments and remittances.")

        }
    }

    private fun View.bwellDrNoorVideo(parentLayout: View) {
        videoTestimonial(parentLayout, 5, "Dr. Noor", "B Well Wellness Center") {
            text = ""
            append("We have been using Balsam Medico since we first started the clinic four years ago. Honestly, the system is ")
            appendBold("very, very, very easy")
            append(" to work with and makes a ")
            appendBold("doctor's life much easier")

        }
    }

    private fun View.drSamarMyChildAndIVideo(parentLayout: View) {
        videoTestimonial(parentLayout, 6, "Dr. Samar", "My Child & I Dental Center") {
            text = ""
            append("I won't just say that using Balsam Medico was one of the right decisions I made—it was actually ")
            appendBold("one of the best decisions I've ever made.")
            append(" Since the day Balsam Medico was introduced to the clinic, ")
            appendBold("everything has truly fallen into place")

        }
    }

    private fun TextView.append(text: String) {
        element.appendText(text)
    }

    private fun TextView.appendBold(text: String) {
        element.append(detached.span {
            style {
                fontWeight = "bold"
            }
            element.innerText = text
        }.element)

    }

    private fun View.testimonialView(
        parentLayout: View,
        personName: String,
        clinicName: String,
        testimonial: String,
        personImage: String,
        clinicLogo: String,
    ) {
        verticalLayout {
            style {
                padding = 16.px
            }
            verticalLayout {
                style {
                    width = 300.px
                    height = matchParent
                    alignItems = Alignment.Center
                    padding = 32.px
                    background = "linear-gradient(0deg, rgba(225,250,250,100) 0%, rgba(243,245,249,246) 100%)"
                    borderRadius = 12.px
                    overflowY = "visible"
                }

                imageView {
                    style {
                        marginTop = (-64).px
                        width = 100.px
                    }
                    element.src = personImage
                }
                verticalFiller(16)

                textView {
                    style {
                        fontSize = 14.px
                        width = matchParent
                        minHeight = 360.px
                        color = AppColors.narnicVeryDarkColor
                    }
                    text = testimonial
                }

                testimonialFooter(personName, clinicName, clinicLogo)
            }
        }

    }

    private fun View.videoTestimonial(
        parentLayout: View,
        index: Int,
        personName: String,
        clinicName: String,
        testimonial: TextView.() -> Unit,
    ) {
        val thumbnailUrl = "/public/img/testimonials/t$index/video_thumbnail.webp"
        verticalLayout {
            style {
                padding = 16.px
            }

            verticalLayout {
                style {
                    width = 300.px
                    height = wrapContent
                    alignItems = Alignment.Center
                    padding = 8.px
                    background = "linear-gradient(0deg, rgba(225,250,250,100) 0%, rgba(243,245,249,246) 100%)"
                    borderRadius = 12.px
                    overflowY = "visible"
                }

                verticalLayout {
                    val buttonParentStyle = style {
                        width = matchParent
                        position = "relative"
                        hover {
                            opacity = 0.8
                        }

                    }
                    onClick = {
                        VideoViewer.show("/public/img/testimonials/t$index/video.mp4", thumbnailUrl)
                    }

                    element.onmouseenter = {
                        parentLayout.element.style.animationPlayState = "paused"
                        Unit.asDynamic()
                    }
                    element.onmouseleave = {
                        parentLayout.element.style.animationPlayState = ""
                        Unit.asDynamic()
                    }
                    imageView {
                        style {
                            width = matchParent
                            height = 268.px
                            borderRadius = 8.px
                            objectFit = "cover"
                            cursor = "pointer"
                        }
                        element.src = thumbnailUrl
                    }
                    imageView {
                        style {
                            width = 50.px
                            objectFit = "contain"
                            position = "absolute"
                            top = 50.percent
                            left = 50.percent
                            transform = "translate(-50%, -50%)"
                            this["pointer-events"] = "none"
                            filter = "grayscale(40%)"
                            onHover(buttonParentStyle) {
                                filter = "grayscale(0%)"
                            }
                        }
                        element.src = "/public/img/play_button.webp"
                    }
                }
                verticalLayout {
                    style {
                        width = matchParent
                        alignItems = Alignment.Center
                        padding = 16.px
                    }

                    textView {
                        style {
//                            fontWeight = "300"
                            fontSize = 14.px
                            width = matchParent
                            minHeight = 140.px
//                            textAlign = TextAlign.Center
                            color = AppColors.narnicVeryDarkColor
                        }
                        testimonial()
                    }
                    verticalFiller(16)
                    testimonialFooter(personName, clinicName, "/public/img/testimonials/t$index/logo.webp")
                }
            }
        }

    }

    private fun LinearLayout.testimonialFooter(
        personName: String,
        clinicName: String,
        clinicLogo: String,
    ) {
        horizontalLayout {
            style {
                width = matchParent
            }
            verticalLayout {
                style {
                    width = weightOf(1)
                }
                textView {
                    style {
                        fontWeight = "800"
                        fontSize = 14.px
                        color = AppColors.narnicVeryDarkColor
                        maxWidth = 100.percent
                    }
                    text = personName
                }
                textView {
                    style {
                        fontSize = 12.px
                        color = AppColors.narnicDarkColor
                        width = 150.px
                        maxWidth = 100.percent
                        minHeight = 34.px
                    }
                    text = clinicName
                }
            }
            horizontalFiller(8)

            imageView {
                style {
                    height = 40.px
                    borderRadius = 2.px
                    objectFit = "cover"
                    cursor = "pointer"
                }
                element.src = clinicLogo
            }
        }
    }

    companion object {
        /**
         *
         *   0% { transform: translateX(0); }
         *   100% { transform: translateX(-50%); }
         */
        val sc = keyframes("scroll") {
            addKeyframeRule("0%") { transform = "translateX(0)" }
            addKeyframeRule("100%") { transform = "translateX(-50%)" }

        }

    }
}


fun RuleSet.onHover(ruleSet: RuleSet, rules: RuleSet.() -> Unit) {
    addCompoundRuleSet(ruleSet.selector.hover, rules)
}
